import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from 'react';

const translations = {
  lv: {
    // Navigation
    home: 'Sākums',
    shops: 'Veikali',
    services: 'Pakalpojumi',
    events: 'Pasākumi',
    projects: 'Projekti',
    login: 'Pieslēgties',
    register: 'Reģistrēties',
    logout: 'Iziet',
    profile: 'Profils',
    myListings: 'Mani sludinājumi',
    messages: 'Ziņas',
    createListing: 'Izveidot sludinājumu',
    
    // Auth
    email: 'E-pasts',
    password: 'Parole',
    name: 'Vārds',
    phone: 'Tālrunis',
    confirmPassword: 'Apstiprināt paroli',
    iAmSeller: 'Es esmu pārdevējs/pakalpojumu sniedzējs',
    forgotPassword: 'Aizmirsi paroli?',
    noAccount: 'Nav konta?',
    haveAccount: 'Jau ir konts?',
    
    // Listing
    title: 'Nosaukums',
    description: 'Apraksts',
    category: 'Kategorija',
    region: 'Reģions',
    price: 'Cena',
    priceType: 'Cenas veids',
    fixed: 'Fiksēta',
    hourly: 'Stundas',
    negotiable: 'Vienošanās',
    free: 'Bezmaksas',
    contactPhone: 'Kontakttālrunis',
    contactEmail: 'Kontakta e-pasts',
    website: 'Mājaslapa',
    address: 'Adrese',
    eventDate: 'Pasākuma datums',
    images: 'Attēli',
    addImage: 'Pievienot attēlu',
    save: 'Saglabāt',
    cancel: 'Atcelt',
    edit: 'Rediģēt',
    delete: 'Dzēst',
    views: 'Skatījumi',
    subcategory: 'Apakškategorija',
    
    // Shop subcategories
    food: 'Ēdiens',
    materials: 'Materiāli',
    handcraft: 'Rokdarbi',
    rental: 'Īre',
    
    // Rental types
    auto: 'Auto',
    bicycle: 'Velosipēdi',
    apartment: 'Dzīvokļi',
    items: 'Priekšmeti',
    
    // Business types
    business: 'Uzņēmumi',
    sauna: 'Pirts',
    kids_party: 'Bērnu ballītes',
    escape_room: 'Escape Room',
    spa: 'SPA',
    restaurant: 'Restorāns',
    cafe: 'Kafejnīca',
    workshop: 'Darbnīca',
    tour: 'Ekskursijas',
    sport: 'Sports',
    entertainment: 'Izklaide',
    other_business: 'Cits',
    
    // Product types (3rd level)
    vegetables: 'Dārzeņi',
    fruits: 'Augļi',
    fish: 'Zivis',
    meat: 'Gaļa',
    bread: 'Maize',
    dairy: 'Piena produkti',
    honey: 'Medus',
    preserves: 'Konservi',
    drinks: 'Dzērieni',
    spices: 'Garšvielas',
    sweets: 'Saldumi',
    other_food: 'Cits ēdiens',
    wood: 'Koks',
    metal: 'Metāls',
    fabric: 'Audums',
    clay: 'Māls',
    stone: 'Akmens',
    other_material: 'Cits materiāls',
    knitting: 'Adīšana',
    sewing: 'Šūšana',
    ceramics: 'Keramika',
    jewelry: 'Rotaslietas',
    candles: 'Sveces',
    soap: 'Ziepes',
    other_handcraft: 'Citi rokdarbi',
    productType: 'Produkta veids',
    businessType: 'Uzņēmuma veids',
    
    // Catalog
    catalog: 'Katalogs',
    catalogs: 'Katalogi',
    joinCatalog: 'Pievienoties katalogam',
    myCatalogs: 'Mani katalogi',
    browseCatalogs: 'Pārlūkot katalogus',
    catalogPromo: 'Akcija! Pirmais gads tikai 100 EUR',
    catalogMonthly: '20 EUR/mēnesī par katalogu',
    contactPerson: 'Kontaktpersona',
    deliveryMethods: 'Piegādes veidi',
    selectCatalogs: 'Izvēlieties katalogus',
    
    // Shop profile
    shopProfile: 'Veikala profils',
    createShop: 'Izveidot veikalu',
    editShop: 'Rediģēt veikalu',
    shopName: 'Veikala nosaukums',
    entityType: 'Juridiskā forma',
    sia: 'SIA',
    ik: 'IK',
    person: 'Civilpersona',
    registrationNumber: 'Reģistrācijas numurs',
    vatNumber: 'PVN numurs',
    legalAddress: 'Juridiskā adrese',
    bankName: 'Bankas nosaukums',
    bankAccount: 'Bankas konts (IBAN)',
    shopDescription: 'Veikala apraksts',
    myShop: 'Mans veikals',
    viewShop: 'Skatīt veikalu',
    requisites: 'Rekvizīti',
    
    // Map & Search
    selectRegion: 'Izvēlieties reģionu',
    allRegions: 'Visi reģioni',
    search: 'Meklēt',
    searchPlaceholder: 'Meklēt sludinājumus...',
    noResults: 'Nav rezultātu',
    
    // Categories
    shop: 'Veikals',
    service: 'Pakalpojumi',
    event: 'Pasākumi',
    project: 'Projekti',
    
    // Home
    heroTitle: 'Ko Latvietis Vēlas',
    heroSubtitle: 'Atklāj vietējos mājražotājus, pakalpojumus un pasākumus visā Latvijā',
    exploreMap: 'Izpēti karti',
    browseCategories: 'Pārlūko kategorijas',
    featuredListings: 'Izceltie sludinājumi',
    viewAll: 'Skatīt visus',
    
    // Profile
    bio: 'Par mani',
    memberSince: 'Dalībnieks kopš',
    sellerProfile: 'Pārdevēja profils',
    updateProfile: 'Atjaunināt profilu',
    
    // Messages
    sendMessage: 'Sūtīt ziņu',
    typeMessage: 'Rakstīt ziņu...',
    noMessages: 'Nav ziņu',
    
    // Misc
    loading: 'Ielādē...',
    error: 'Kļūda',
    success: 'Veiksmīgi',
    confirm: 'Apstiprināt',
    eur: '€',
    perHour: '/h'
  },
  en: {
    // Navigation
    home: 'Home',
    shops: 'Shops',
    services: 'Services',
    events: 'Events',
    projects: 'Projects',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    profile: 'Profile',
    myListings: 'My Listings',
    messages: 'Messages',
    createListing: 'Create Listing',
    
    // Auth
    email: 'Email',
    password: 'Password',
    name: 'Name',
    phone: 'Phone',
    confirmPassword: 'Confirm Password',
    iAmSeller: 'I am a seller/service provider',
    forgotPassword: 'Forgot password?',
    noAccount: "Don't have an account?",
    haveAccount: 'Already have an account?',
    
    // Listing
    title: 'Title',
    description: 'Description',
    category: 'Category',
    region: 'Region',
    price: 'Price',
    priceType: 'Price Type',
    fixed: 'Fixed',
    hourly: 'Hourly',
    negotiable: 'Negotiable',
    free: 'Free',
    contactPhone: 'Contact Phone',
    contactEmail: 'Contact Email',
    website: 'Website',
    address: 'Address',
    eventDate: 'Event Date',
    images: 'Images',
    addImage: 'Add Image',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    views: 'Views',
    subcategory: 'Subcategory',
    
    // Shop subcategories
    food: 'Food',
    materials: 'Materials',
    handcraft: 'Handcrafts',
    rental: 'Rental',
    
    // Rental types
    auto: 'Cars',
    bicycle: 'Bicycles',
    apartment: 'Apartments',
    items: 'Items',
    
    // Business types
    business: 'Businesses',
    sauna: 'Sauna',
    kids_party: 'Kids Parties',
    escape_room: 'Escape Room',
    spa: 'SPA',
    restaurant: 'Restaurant',
    cafe: 'Café',
    workshop: 'Workshop',
    tour: 'Tours',
    sport: 'Sports',
    entertainment: 'Entertainment',
    other_business: 'Other',
    
    // Product types
    vegetables: 'Vegetables', fruits: 'Fruits', fish: 'Fish', meat: 'Meat',
    bread: 'Bread', dairy: 'Dairy', honey: 'Honey', preserves: 'Preserves',
    drinks: 'Drinks', spices: 'Spices', sweets: 'Sweets', other_food: 'Other food',
    wood: 'Wood', metal: 'Metal', fabric: 'Fabric', clay: 'Clay',
    stone: 'Stone', other_material: 'Other material',
    knitting: 'Knitting', sewing: 'Sewing', ceramics: 'Ceramics',
    jewelry: 'Jewelry', candles: 'Candles', soap: 'Soap', other_handcraft: 'Other handcraft',
    productType: 'Product Type',
    businessType: 'Business Type',
    
    // Catalog
    catalog: 'Catalog',
    catalogs: 'Catalogs',
    joinCatalog: 'Join Catalog',
    myCatalogs: 'My Catalogs',
    browseCatalogs: 'Browse Catalogs',
    catalogPromo: 'Promo! First year only 100 EUR',
    catalogMonthly: '20 EUR/month per catalog',
    contactPerson: 'Contact Person',
    deliveryMethods: 'Delivery Methods',
    selectCatalogs: 'Select Catalogs',
    
    // Shop profile
    shopProfile: 'Shop Profile',
    createShop: 'Create Shop',
    editShop: 'Edit Shop',
    shopName: 'Shop Name',
    entityType: 'Legal Entity Type',
    sia: 'Ltd (SIA)',
    ik: 'Sole Proprietor (IK)',
    person: 'Individual',
    registrationNumber: 'Registration Number',
    vatNumber: 'VAT Number',
    legalAddress: 'Legal Address',
    bankName: 'Bank Name',
    bankAccount: 'Bank Account (IBAN)',
    shopDescription: 'Shop Description',
    myShop: 'My Shop',
    viewShop: 'View Shop',
    requisites: 'Requisites',
    
    // Map & Search
    selectRegion: 'Select region',
    allRegions: 'All regions',
    search: 'Search',
    searchPlaceholder: 'Search listings...',
    noResults: 'No results',
    
    // Categories
    shop: 'Shop',
    service: 'Services',
    event: 'Events',
    project: 'Projects',
    
    // Home
    heroTitle: 'What Latvian Wants',
    heroSubtitle: 'Discover local producers, services and events across Latvia',
    exploreMap: 'Explore Map',
    browseCategories: 'Browse Categories',
    featuredListings: 'Featured Listings',
    viewAll: 'View All',
    
    // Profile
    bio: 'About me',
    memberSince: 'Member since',
    sellerProfile: 'Seller Profile',
    updateProfile: 'Update Profile',
    
    // Messages
    sendMessage: 'Send Message',
    typeMessage: 'Type a message...',
    noMessages: 'No messages',
    
    // Misc
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    confirm: 'Confirm',
    eur: '€',
    perHour: '/h'
  },
  ru: {
    // Navigation
    home: 'Главная',
    shops: 'Магазины',
    services: 'Услуги',
    events: 'Мероприятия',
    projects: 'Проекты',
    login: 'Войти',
    register: 'Регистрация',
    logout: 'Выйти',
    profile: 'Профиль',
    myListings: 'Мои объявления',
    messages: 'Сообщения',
    createListing: 'Создать объявление',

    // Auth
    email: 'Эл. почта',
    password: 'Пароль',
    name: 'Имя',
    phone: 'Телефон',
    confirmPassword: 'Подтвердите пароль',
    iAmSeller: 'Я продавец/поставщик услуг',
    forgotPassword: 'Забыли пароль?',
    noAccount: 'Нет аккаунта?',
    haveAccount: 'Уже есть аккаунт?',

    // Listing
    title: 'Название',
    description: 'Описание',
    category: 'Категория',
    region: 'Регион',
    price: 'Цена',
    priceType: 'Тип цены',
    fixed: 'Фиксированная',
    hourly: 'Почасовая',
    negotiable: 'Договорная',
    free: 'Бесплатно',
    contactPhone: 'Контактный телефон',
    contactEmail: 'Контактная эл. почта',
    website: 'Веб-сайт',
    address: 'Адрес',
    eventDate: 'Дата мероприятия',
    images: 'Изображения',
    addImage: 'Добавить изображение',
    save: 'Сохранить',
    cancel: 'Отмена',
    edit: 'Редактировать',
    delete: 'Удалить',
    views: 'Просмотры',
    subcategory: 'Подкатегория',

    // Shop subcategories
    food: 'Еда',
    materials: 'Материалы',
    handcraft: 'Рукоделие',
    rental: 'Аренда',

    // Rental types
    auto: 'Автомобили',
    bicycle: 'Велосипеды',
    apartment: 'Квартиры',
    items: 'Вещи',

    // Business types
    business: 'Компании',
    sauna: 'Баня',
    kids_party: 'Детские праздники',
    escape_room: 'Эскейп-рум',
    spa: 'СПА',
    restaurant: 'Ресторан',
    cafe: 'Кафе',
    workshop: 'Мастерская',
    tour: 'Экскурсии',
    sport: 'Спорт',
    entertainment: 'Развлечения',
    other_business: 'Другое',

    // Product types
    vegetables: 'Овощи', fruits: 'Фрукты', fish: 'Рыба', meat: 'Мясо',
    bread: 'Хлеб', dairy: 'Молочные продукты', honey: 'Мёд', preserves: 'Консервы',
    drinks: 'Напитки', spices: 'Специи', sweets: 'Сладости', other_food: 'Другая еда',
    wood: 'Дерево', metal: 'Металл', fabric: 'Ткань', clay: 'Глина',
    stone: 'Камень', other_material: 'Другой материал',
    knitting: 'Вязание', sewing: 'Шитьё', ceramics: 'Керамика',
    jewelry: 'Украшения', candles: 'Свечи', soap: 'Мыло', other_handcraft: 'Другое рукоделие',
    productType: 'Тип продукта',
    businessType: 'Тип компании',

    // Catalog
    catalog: 'Каталог',
    catalogs: 'Каталоги',
    joinCatalog: 'Присоединиться к каталогу',
    myCatalogs: 'Мои каталоги',
    browseCatalogs: 'Обзор каталогов',
    catalogPromo: 'Акция! Первый год всего 100 EUR',
    catalogMonthly: '20 EUR/месяц за каталог',
    contactPerson: 'Контактное лицо',
    deliveryMethods: 'Способы доставки',
    selectCatalogs: 'Выберите каталоги',

    // Shop profile
    shopProfile: 'Профиль магазина',
    createShop: 'Создать магазин',
    editShop: 'Редактировать магазин',
    shopName: 'Название магазина',
    entityType: 'Юридическая форма',
    sia: 'ООО (SIA)',
    ik: 'ИП (IK)',
    person: 'Физ. лицо',
    registrationNumber: 'Регистрационный номер',
    vatNumber: 'Номер НДС',
    legalAddress: 'Юридический адрес',
    bankName: 'Название банка',
    bankAccount: 'Банковский счёт (IBAN)',
    shopDescription: 'Описание магазина',
    myShop: 'Мой магазин',
    viewShop: 'Посмотреть магазин',
    requisites: 'Реквизиты',

    // Map & Search
    selectRegion: 'Выберите регион',
    allRegions: 'Все регионы',
    search: 'Поиск',
    searchPlaceholder: 'Поиск объявлений...',
    noResults: 'Нет результатов',

    // Categories
    shop: 'Магазин',
    service: 'Услуги',
    event: 'Мероприятия',
    project: 'Проекты',

    // Home
    heroTitle: 'Что хочет латвиец',
    heroSubtitle: 'Откройте местных производителей, услуги и мероприятия по всей Латвии',
    exploreMap: 'Открыть карту',
    browseCategories: 'Обзор категорий',
    featuredListings: 'Избранные объявления',
    viewAll: 'Смотреть все',

    // Profile
    bio: 'Обо мне',
    memberSince: 'Участник с',
    sellerProfile: 'Профиль продавца',
    updateProfile: 'Обновить профиль',

    // Messages
    sendMessage: 'Отправить сообщение',
    typeMessage: 'Введите сообщение...',
    noMessages: 'Нет сообщений',

    // Misc
    loading: 'Загрузка...',
    error: 'Ошибка',
    success: 'Успешно',
    confirm: 'Подтвердить',
    eur: '€',
    perHour: '/ч'
  }
};

// Supported languages in cycle order
export const SUPPORTED_LANGUAGES = ['lv', 'en', 'ru'];

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('kolv_language');
    return SUPPORTED_LANGUAGES.includes(saved) ? saved : 'lv';
  });

  useEffect(() => {
    localStorage.setItem('kolv_language', language);
  }, [language]);

  const t = useCallback((key) => {
    return (translations[language] && translations[language][key]) || translations.en[key] || key;
  }, [language]);

  // Inline 3-language helper for strings not in the dictionary. Falls back
  // ru -> en -> lv so partially-translated screens degrade gracefully.
  const tr = useCallback((lv, en, ru) => {
    if (language === 'lv') return lv;
    if (language === 'ru') return ru ?? en ?? lv;
    return en ?? lv;
  }, [language]);

  const toggleLanguage = useCallback(() => {
    setLanguage(prev => {
      const idx = SUPPORTED_LANGUAGES.indexOf(prev);
      return SUPPORTED_LANGUAGES[(idx + 1) % SUPPORTED_LANGUAGES.length];
    });
  }, []);

  const value = useMemo(() => ({
    language, setLanguage, toggleLanguage, t, tr
  }), [language, toggleLanguage, t, tr]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
